import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChatDefaultMessages, IChatMessage, IChatSlice } from "../../interfaces/interfaces";
import { ChatType } from "interfaces";

const ChatSliceState: IChatSlice = {
    messages: undefined,
    usersInfoInChat: [],
    chatEnabled: undefined,
    showChat: true,
    socket: undefined,
    roomId: undefined,
    chatType: ChatType.public,
    messageCount: 0,
    defaultMessages: [],
    pinMessage: null
};

export const chatSlice = createSlice({
    name: "chat",
    initialState: ChatSliceState,
    reducers: {
        setMessages: (state, action: PayloadAction<IChatMessage[] | undefined>) => {
            state.messages = action.payload;
        },
        setUsersInfoInChat: (state, action: PayloadAction<any>) => {
            state.usersInfoInChat = action.payload;
        },
        setChatEnabled: (state, action: PayloadAction<boolean | undefined>) => {
            state.chatEnabled = action.payload;
        },
        setShowChat: (state, action: PayloadAction<boolean>) => {
            state.showChat = action.payload;
        },
        setSocket: (state, action: PayloadAction<any>) => {
            state.socket = action.payload;
        },
        setRoomId: (state, action: PayloadAction<any>) => {
            state.roomId = action.payload;
        },
        setChatType: (state, action: PayloadAction<ChatType>) => {
            state.chatType = action.payload;
        },
        setMessageCount: (state, action: PayloadAction<number>) => {
            state.messageCount = action.payload;
        },
        setDefaultMessages: (state, action: PayloadAction<IChatDefaultMessages[]>) => {
            state.defaultMessages = action.payload;
        },
        setPinMessage: (state, action: PayloadAction<string | null>) => {
            state.pinMessage = action.payload;
        },
        setClearChatSlice: () => {
            return ChatSliceState;
        }
    }
});

export const {
    setMessages,
    setUsersInfoInChat,
    setChatEnabled,
    setShowChat,
    setSocket,
    setClearChatSlice,
    setRoomId,
    setChatType,
    setMessageCount,
    setDefaultMessages,
    setPinMessage
} = chatSlice.actions;

export default chatSlice.reducer;
